export interface EnvironmentConfig {
  environment: 'dev' | 'qa' | 'sand' | 'prod';
  clientId: string;
  authority: string;
  apiBaseUrl: string;
  odataBaseUrl: string;
}

export interface InternalEnvironmentConfig extends EnvironmentConfig {
  /** Is the current code running in local development mode. */
  localDevelopmentMode?: boolean;
  /** Is the current code running inside the CRM UI version. */
  crmMode: boolean;
  /** Is the current code running inside an iframe. */
  isInIframe: boolean;
}

const environments: EnvironmentConfig['environment'][] = [
  'dev',
  'qa',
  'sand',
  'prod',
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const actualConfig: EnvironmentConfig | undefined = (window as any)
  .configuration;

const defaultConfig: EnvironmentConfig = {
  environment: 'dev',
  clientId: 'dxp-AgentUI-2',
  authority: 'https://auth-dev.telxl.net',
  apiBaseUrl: 'https://api-dev.telxl.net',
  odataBaseUrl: 'https://odata-dev.telxl.net',
};

const usedConfig =
  actualConfig && environments.includes(actualConfig.environment)
    ? actualConfig
    : defaultConfig;

const usedInternalConfig: InternalEnvironmentConfig = {
  ...usedConfig,
  localDevelopmentMode: window.location.hostname === 'localhost',
  crmMode: window.location.pathname.startsWith('/crm'),
  isInIframe: inIsIframe(),
};

export default Object.freeze(usedInternalConfig);

function inIsIframe() {
  try {
    return window.self !== window.top;
  }
  catch {
    return true;
  }
}